{
  "title": "Тіркелгі",
  "registerTitle": "Тіркелу",
  "subtitle": "Email, Google, телефон немесе Telegram арқылы кіріңіз - кез келген тәсіл бір аккаунт пен әмиянды ашады.",
  "email": "Email",
  "password": "Құпия сөз",
  "showPassword": "Көрсету",
  "hidePassword": "Жасыру",
  "acceptTerms": "Пайдалану ережелерін қабылдаймын",
  "registerCta": "Тіркелу",
  "haveAccount": "Тіркелгіңіз бар ма?",
  "needAccount": "Тіркелгі жоқ па?",
  "telegramHint": "Telegram Mini App автокіруі қосулы (initData серверде тексеріледі).",
  "unavailable": "Аутентификация әзірге белсенді емес",
  "telegramSoon": "Telegram арқылы кіру жақында",
  "webSoon": "Веб кіру жақында",
  "googleDisabled": "Google login disabled until OAuth is configured",
  "googleReady": "Continue with Google",
  "smsDisabled": "SMS login disabled until an SMS provider is configured",
  "smsReady": "Continue with phone",
  "orEmail": "Email",
  "registerShort": "Тіркелу",
  "loginTitle": "Кіру",
  "tabEmail": "Email",
  "tabPhone": "Телефон",
  "emailPlaceholder": "E-mail",
  "phoneUnavailableTitle": "Телефонмен кіру әзірше белсенді емес",
  "phoneUnavailableBody": "SMS қызметі қосылмаған. Email және құпиясөзбен жалғастырыңыз.",
  "phonePlaceholder": "50 123 45 67",
  "phoneInvalidAz": "Әзербайжанның 9 таңбалы мобильді нөмірін енгізіңіз (мыс. 50 123 45 67).",
  "casinoBonusInactive": "Науқан әлі белсенді емес",
  "socialMethods": "Әлеуметтік кіру",
  "orContinue": "немесе",
  "continueWithTelegram": "Telegram арқылы жалғастыру",
  "casinoBonus": "Казино бонусы",
  "noRegistrationBonus": "Қазір тіркелуде таңдалатын бонус жоқ.",
  "promoToggle": "Промокод қосу",
  "promoPlaceholder": "Промокод",
  "promoHint": "Код тіркелу кезінде автоматты қолданылмайды. Кейін Бонустар бетінде жазуға болады.",
  "acceptTermsPrefix": "Мен ",
  "acceptTermsLink": "пайдалану ережелерін",
  "acceptTermsSuffix": " оқыдым және келісемін.",
  "acceptTermsRequired": "Тіркелу үшін ережелерге келісу керек.",
  "termsMissingNote": "Ережелер жобасы /qaydalar бетінде. Жариялау үшін бөлек рұқсат керек. Тіркелу үшін белгілеңіз.",
  "registerSubmit": "Тіркелу",
  "loginSubmit": "Кіру",
  "socialSoon": "Google және Telegram веб кіруі әлі белсенді емес.",
  "haveAccountPrompt": "Аккаунтым бар?",
  "haveAccountAction": "Кіру",
  "needAccountPrompt": "Аккаунт керек пе?",
  "needAccountAction": "Тіркелу",
  "resetPassword": "Құпиясөзді қалпына келтіру",
  "closeDialog": "Жабу",
  "forgotLink": "Құпиясөзді ұмыттыңыз ба?",
  "forgotTitle": "Құпиясөзді қалпына келтіру",
  "forgotIntro": "Аккаунтыңыздың email-ін енгізіңіз. Ол тіркелген болса, қалпына келтіру сілтемесін жібереміз.",
  "forgotCta": "Сілтемені жіберу",
  "forgotSent": "Осы email-мен аккаунт бар болса, сілтеме жіберілді. Кіріс және спам қалталарын тексеріңіз.",
  "sendAgain": "Қайта жіберу",
  "emailDeliveryOff": "Бұл серверде хат жіберу әлі бапталмаған, хат келмейді.",
  "backToLogin": "Кіруге оралу",
  "resetTitle": "Жаңа құпиясөз",
  "newPassword": "Жаңа құпиясөз",
  "confirmPassword": "Құпиясөзді қайталаңыз",
  "passwordsDontMatch": "Құпиясөздер сәйкес емес",
  "passwordRules": "Кемінде 8 таңба: әріптермен бірге сандар немесе белгілер.",
  "resetCta": "Құпиясөзді сақтау",
  "resetDone": "Құпиясөз өзгертілді. Барлық сеанстар жабылды - жаңа құпиясөзбен кіріңіз.",
  "linkInvalid": "Сілтеме жарамсыз, мерзімі өткен немесе бұрын қолданылған.",
  "requestNewLink": "Жаңа сілтеме сұрау",
  "checking": "Тексерілуде...",
  "verifyTitle": "Email растау",
  "verifyIntro": "Email мекенжайын растау үшін түймені басыңыз.",
  "verifyCta": "Email растау",
  "verifyDone": "Email расталды. Рақмет!",
  "verifyResendHint": "Жаңа растау хатын «Қауіпсіздік» бетінде сұрай аласыз.",
  "securityTitle": "Аккаунт қауіпсіздігі",
  "emailVerified": "Расталған",
  "emailNotVerified": "Расталмаған",
  "resendVerification": "Растау хатын қайта жіберу",
  "verificationSent": "Растау хаты жіберілді.",
  "verificationSentAfterRegister": "Аккаунт жасалды. Email-іңізге растау сілтемесін жібердік.",
  "phoneTitle": "Телефонмен кіру",
  "phoneLinkTitle": "Телефон нөмірін қосу",
  "phoneLabel": "Телефон нөмірі",
  "phoneHint": "Әзірбайжан нөмірлерін 050 123 45 67 түрінде жазуға болады. Басқа елдер үшін + белгісінен бастаңыз.",
  "sendCode": "Кодты жіберу",
  "codeLabel": "SMS-тегі код",
  "codeSentTo": "{{phone}} нөміріне 6 таңбалы код жібердік.",
  "verifyCode": "Растау",
  "resendCode": "Кодты қайта жіберу",
  "resendIn": "{{seconds}} с кейін қайта жіберу",
  "changeNumber": "Нөмірді өзгерту",
  "phoneLinked": "Телефон нөмірі қосылды.",
  "googleWorking": "Google арқылы кіруде...",
  "telegramWorking": "Telegram арқылы кіруде...",
  "telegramCancelled": "Telegram арқылы кіру тоқтатылды.",
  "googleLinked": "Google аккаунты байланыстырылды.",
  "googleCancelled": "Google арқылы кіру тоқтатылды.",
  "signInToLink": "Аккаунтыңызға кіріңіз",
  "telegramWidgetUnavailable": "Сайтта Telegram арқылы кіру бот домені бапталғаннан кейін қолжетімді болады. Telegram ішінде Mini App сізді автоматты түрде кіргізеді.",
  "telegramLinked": "Telegram байланыстырылды.",
  "signInRequired": "Аккаунт қауіпсіздігін басқару үшін кіріңіз.",
  "loginMethods": "Кіру тәсілдері",
  "methodPassword": "Email және құпиясөз",
  "methodGoogle": "Google",
  "methodPhone": "Телефон (SMS)",
  "methodTelegram": "Telegram",
  "linked": "Байланыстырылған",
  "notLinked": "Байланыстырылмаған",
  "link": "Байланыстыру",
  "unlink": "Ажырату",
  "unlinked": "Кіру тәсілі жойылды.",
  "lastMethodHint": "Жалғыз кіру тәсілін жою мүмкін емес.",
  "unavailableProvider": "Бапталмаған",
  "changePasswordTitle": "Құпиясөзді өзгерту",
  "setPasswordTitle": "Құпиясөз орнату",
  "currentPassword": "Ағымдағы құпиясөз",
  "savePassword": "Құпиясөзді сақтау",
  "passwordSaved": "Құпиясөз сақталды. Басқа сеанстар жабылды.",
  "changeEmailTitle": "Email өзгерту",
  "newEmail": "Жаңа email",
  "saveEmail": "Email сақтау",
  "emailSaved": "Email жаңартылды. Жаңа мекенжайды хаттан растаңыз.",
  "reauthTitle": "Бұл сіз екеніңізді растаңыз",
  "reauthIntro": "Қауіпсіздік үшін жалғастыру алдында құпиясөзді енгізіңіз.",
  "reauthPasswordless": "Қауіпсіздік үшін жалғастыру алдында қайта кіріңіз.",
  "reauthCta": "Жалғастыру",
  "mfaCode": "Аутентификатор коды",
  "signInAgain": "Қайта кіру",
  "sessionsTitle": "Сеанстар",
  "logout": "Шығу",
  "logoutAll": "Барлық құрылғылардан шығу",
  "phoneNotSet": "Телефон нөмірі жоқ",
  "errors": {
    "invalid_credentials": "Email немесе құпиясөз қате.",
    "too_many_requests": "Әрекеттер тым көп. Біраз күтіп, қайталап көріңіз.",
    "email_taken": "Бұл email тіркелген. Аккаунтқа кіріңіз.",
    "password_too_short": "Құпиясөз тым қысқа (кемінде 8 таңба).",
    "password_too_long": "Құпиясөз тым ұзын (ең көбі 128 таңба).",
    "password_too_weak": "Құпиясөз әлсіз. Әріптерді сандармен немесе белгілермен араластырыңыз.",
    "password_too_common": "Бұл құпиясөз тым кең таралған. Басқасын таңдаңыз.",
    "password_contains_email": "Құпиясөзде email атыңыз болмауы керек.",
    "invalid_or_expired_token": "Сілтеме жарамсыз, мерзімі өткен немесе бұрын қолданылған.",
    "invalid_password": "Құпиясөз қате.",
    "invalid_email": "Дұрыс email енгізіңіз.",
    "email_not_set": "Аккаунтта email жоқ.",
    "reauth_required": "Жалғастыру үшін бұл сіз екеніңізді растаңыз.",
    "password_not_set": "Бұл аккаунтта құпиясөз жоқ. Байланыстырылған тәсілмен қайта кіріңіз.",
    "email_required_for_password": "Құпиясөз орнату алдында email қосыңыз.",
    "email_delivery_unavailable": "Хат жіберу әлі бапталмаған.",
    "sms_disabled": "SMS арқылы кіру әлі қолжетімсіз.",
    "phone_auth_disabled": "Телефонмен тіркелу және SMS кіру уақытша өшірілген.",
    "sms_delivery_failed": "SMS жіберілмеді. Кейінірек қайталаңыз.",
    "invalid_phone": "Дұрыс телефон нөмірін енгізіңіз.",
    "resend_cooldown": "Жаңа код сұрамас бұрын біраз күтіңіз.",
    "otp_invalid": "Код қате немесе мерзімі өткен.",
    "otp_expired": "Кодтың мерзімі өтті. Жаңасын сұраңыз.",
    "otp_attempts_exceeded": "Қате кодтар тым көп. Жаңа код сұраңыз.",
    "phone_in_use": "Бұл нөмір басқа аккаунтқа тиесілі.",
    "phone_signin_conflict_retry": "Қайталап көріңіз.",
    "google_oauth_disabled": "Google арқылы кіру әлі қолжетімсіз.",
    "telegram_oidc_disabled": "Telegram арқылы веб-кіру әлі қолжетімсіз.",
    "google_account_exists_link_required": "Осы Google email-імен аккаунт бар. Алдымен оған кіріп, содан кейін «Қауіпсіздік» бетінде Google-ды байланыстырыңыз.",
    "google_linked_to_other_account": "Бұл Google аккаунты басқа VBB PLAY аккаунтына байланыстырылған.",
    "google_other_account_linked": "Басқа Google аккаунты байланыстырылған. Алдымен оны ажыратыңыз.",
    "google_signin_conflict_retry": "Қайталап көріңіз.",
    "invalid_state": "Кіру әрекетінің мерзімі өтті немесе басқа браузерде басталды. Қайталап көріңіз.",
    "state_expired": "Кіру әрекетінің мерзімі өтті. Қайталап көріңіз.",
    "nonce_mismatch": "Google арқылы кіруді тексеру мүмкін болмады. Қайталап көріңіз.",
    "invalid_id_token": "Google арқылы кіруді тексеру мүмкін болмады. Қайталап көріңіз.",
    "token_exchange_failed": "Google кіруді растамады. Қайталап көріңіз.",
    "signing_key_unavailable": "Google уақытша қолжетімсіз. Қайталап көріңіз.",
    "link_session_mismatch": "Байланыстыруды бастаған аккаунтқа кіріңіз.",
    "telegram_already_linked": "Бұл Telegram басқа VBB PLAY аккаунтына байланыстырылған.",
    "telegram_other_account_linked": "Басқа Telegram байланыстырылған. Алдымен оны ажыратыңыз.",
    "telegram_payload_required": "Telegram кіру деректерін бермеді.",
    "auth_data_replayed": "Бұл Telegram кіруі бұрын қолданылған. Қайта кіріңіз.",
    "auth_data_expired": "Telegram кіруінің мерзімі өтті. Қайталап көріңіз.",
    "invalid_hash": "Telegram арқылы кіруді тексеру мүмкін болмады.",
    "last_login_method": "Жалғыз кіру тәсілін жою мүмкін емес.",
    "account_suspended": "Аккаунт тоқтатылған. Қолдау қызметіне жүгініңіз.",
    "admin_email_change_disabled": "Әкімші email-ін тек оператор өзгерте алады.",
    "mfa_required": "Аутентификатор қолданбасындағы кодты енгізіңіз."
  }
}
